import React, {useContext} from 'react'
import StepInformationUI from './StepInformation'
import {AppContext} from '../../../contexts/AppContext'

export default function StepInformation() {
  const [state, setState] = useContext(AppContext)
  const {step3NoteLeaving} = state
  const errors = state.errors || {}
  const handleChange = label => event => {
    const {value} = event.target
    setState(state => ({...state, [label]: value}))
  }

  return (
    <StepInformationUI
      onChange={handleChange}
      step3NoteLeaving={step3NoteLeaving}
      errors={errors}
    />
  )
}
